




















import { computed, defineComponent, ref } from "@vue/composition-api";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import useBalance from "@/hooks/useBalance";
import providers from "@/lib/api";
import config from "@/config";
import MoreMenuMoney from "../MoreMenuMoney";
import MoreMenuStats from "../MoreMenuStats";
import MoreMenuUser from "../MoreMenuUser";
import SwitchAccount from "../SwitchAccount";

export default defineComponent({
  name: "MoreMenuProfileInfo",
  components: { MoreMenuUser, MoreMenuMoney, MoreMenuStats, SwitchAccount },
  setup() {
    const { balance } = useBalance();
    const { authUser, isCreator, isAdmin, authorities } = useAuthUser();
    const loading = ref(false);
    const followersCount = ref(0);
    const subscribersCount = ref(0);
    const isSwitchAccountEnabled = computed(() => config.featureSwitchAccount);
    const showPayoutRequestButton = computed(
      () => config.featurePayoutRequest && checkAuthorities(authorities.value, ["createMyPayoutRequest"])
    );

    const getSubscribersCount = async () => {
      if (!authUser.value || !isCreator.value) return;
      const res = await providers.SubscriptionProvider.search(
        {
          data: { providerId: authUser.value.id, expired: false, size: 1 },
        },
        ["id"]
      );
      subscribersCount.value = res.totalRecords;
    };

    const getFollowersCount = async () => {
      if (!authUser.value || !isCreator.value) return;
      const res = await providers.FollowingsProvider.getStatistic({ ids: [authUser.value.id] });
      followersCount.value = res[0]?.followerCount ?? 0;
    };

    const getData = async () => {
      try {
        loading.value = true;
        await Promise.all([getFollowersCount(), getSubscribersCount()]);
      } finally {
        loading.value = false;
      }
    };

    getData();

    return {
      loading,
      isAdmin,
      isCreator,
      showPayoutRequestButton,
      balance,
      followersCount,
      subscribersCount,
      isSwitchAccountEnabled,
    };
  },
});
